import styled, { keyframes } from 'styled-components';
import { DeprecatedGrid as Grid, Row, media } from '@simplywallst/ui-core';

const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;
const onEnter = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const Wrapper = styled('section')`
  background-color: ${({ theme }) => theme.color.charcoal};
  position: relative;
  width: 100%;
  min-height: 420px;
  z-index: 0;
  animation: ${onEnter} 0.5s ${cubicBezier};
`;

export const Chart = styled('svg')`
  position: absolute;
  top: 0;
  bottom: 0;
`;

interface Props {
  hover: boolean;
}

export const VerticalCrosshair = styled('rect')<Props>`
  opacity: ${({ hover }) => (hover ? 1 : 0)};
  transition: opacity 0.1s;
`;

export const MarkerWrapper = styled('div')`
  position: relative;
  z-index: 1;
  > svg {
    display: block;
  }
`;

export const Status = styled('div')`
  ${({ theme }) => theme.typography.tiny}
  color: ${({ theme }) => theme.color.whiteRGBA(0.3)};
  background: ${({ theme }) => theme.color.whiteRGBA(0.05)};
  padding: ${({ theme }) => theme.x1spacePx / 2}px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 636px;
`;

export const ChartHeader = styled('div')`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.color.charcoal};
  border-radius: 5px 5px 0 0;
`;

export const ToolTipText = styled('span')`
  display: inline-block;
  max-width: 200px;
`;

export type Visibility = 'visible' | 'hidden';

interface TableWrapperProps {
  visibility: Visibility;
}

export const TableWrapper = styled('div')<TableWrapperProps>`
  height: 636px;
  width: ${({ theme }) => `calc(100% - ${theme.x8spacePx}px)`};
  left: ${({ theme }) => theme.x4spacePx}px;
  position: absolute;
  overflow-y: auto;
  z-index: 10;
  background-color: ${({ theme }) => theme.color.charcoal};
  visibility: ${({ visibility }) => visibility};
  ${media.mdDown`
    left: 0;
    right: 0;
    width: 100%;
  `};
`;

export const ValuationSelection = styled(Row)`
  flex: 1;
`;

interface PETooltipProp {
  flip?: boolean;
  x: number;
}

export const PETooltip = styled.div.attrs<PETooltipProp>(({ x }) => ({
  style: {
    transform: `translateX(${x || 0}px)`,
  },
}))<PETooltipProp>`
  background-color: ${({ theme }) => theme.color.white};
  border-radius: 4px;
  width: 296px;
  padding-left: ${({ theme }) => theme.x2spacePx}px;
  margin-top: ${({ theme }) => theme.x1spacePx}px;
  > span {
    color: ${({ theme }) => theme.color.charcoal};
    ${({ theme }) => theme.typography.smallStrong}
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-top: ${({ theme }) => theme.x1spacePx / 2}px;
  }
  > p {
    color: ${({ theme }) => theme.color.charcoal};
    ${({ theme }) => theme.typography.megaStrong}
    margin: ${({ theme }) => theme.x1spacePx}px;
    text-align: right;
    float: right;
  }
  > time {
    ${({ theme }) => theme.typography.tiny}
    color: ${({ theme }) => theme.color.charcoalRGBA(0.7)};
    width: ${({ theme }) => theme.x14spacePx + 2}px;
  }
`;

export const Tip = styled.div.attrs<PETooltipProp>(({ x, flip }) => ({
  style: {
    transform: `translateX(${(x || 0) - (!flip ? 8 : 0)}px)`,
  },
}))<PETooltipProp>`
  width: 0;
  height: 0;
  border-top: 10px solid white;
  ${({ flip }) =>
    `${flip ? 'border-right' : 'border-left'}: 8px solid transparent;`}
`;

export const TopChartHeader = styled(Grid)`
  width: 100%;
  padding: ${({ theme }) => theme.x1spacePx}px
    ${({ theme }) => theme.x2spacePx}px;
  border-bottom: 1px solid ${({ theme }) => theme.color.spaceGray};
`;

export const ChartWrapper = styled.div`
  ${media.mdDown`
    margin: ${({ theme }) => `0 ${-theme.x2spacePx}px`}
  `};
`;

export const ChartBottomWrapper = styled(Row)`
  background-color: ${({ theme }) => theme.color.charcoal};
  border-radius: 0 0 5px 5px;
  padding: 0 ${({ theme }) => theme.x2spacePx}px
    ${({ theme }) => theme.x2spacePx}px;
  ${media.mdDown`
    margin: ${({ theme }) => `0 ${-theme.x2spacePx}px`}
  `};
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
`;
